<template>
  <div v-if="roleInOrganizationError || roleInVesselError" class="fill-height">
    <GenericError />
  </div>

  <div v-else-if="roleInOrganizationLoading || roleInVesselLoading" class="content-spinner">
    <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GenericError from '@/components/error/GenericError'

export default {
  components: {
    GenericError
  },

  data() {
    return {
      keycloakUser: {}
    }
  },

  computed: {
    ...mapGetters({
      roleInOrganizationError: 'roleinorganization/list/error',
      roleInOrganizationLoading: 'roleinorganization/list/isLoading',
      roleInOrganizations: 'roleinorganization/list/items',
      roleInVesselError: 'roleinvessel/list/error',
      roleInVesselLoading: 'roleinvessel/list/isLoading',
      roleInVessels: 'roleinvessel/list/items'
    }),

    isLoading() {
      return this.roleInVesselLoading || this.roleInOrganizationLoading
    },

    error() {
      return this.roleInOrganizationError || this.roleInVesselError
    }
  },

  watch: {
    error: function() {
      localStorage.removeItem('user')
      this.$keycloak.logout()
    },

    isLoading: function(isLoading) {
      if (isLoading) {
        return
      }

      this.keycloakUser.roleInOrganizations = [...this.roleInOrganizations]
      this.keycloakUser.roleInVessels = [...this.roleInVessels]

      this.$security.setUser(this.keycloakUser)

      this.$emit('setUserInfo', this.keycloakUser)

      this.$store.commit('mapSetShow', true)

      if (localStorage.getItem('callbackUrl')) {
        const callbackUrl = localStorage.getItem('callbackUrl')
        localStorage.removeItem('callbackUrl')
        this.$router.replace(callbackUrl)
      } else {
        this.$router.replace('/')
      }
    }
  },

  created() {
    this.$store.commit('mapSetShow', false)

    this.$keycloak.loadUserInfo().then(user => {
      this.keycloakUser = user
      this.roleInOrganizationGetPage('/role_in_organizations?pagination=false&user=' + user.sub)
      this.roleInVesselGetPage('/role_in_vessels?pagination=false&user=' + user.sub)
    })
  },

  methods: {
    ...mapActions({
      roleInVesselGetPage: 'roleinvessel/list/default',
      roleInOrganizationGetPage: 'roleinorganization/list/default'
    })
  }
}
</script>
